/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OemRateEntryDto } from './OemRateEntryDto';
import {
    OemRateEntryDtoFromJSON,
    OemRateEntryDtoFromJSONTyped,
    OemRateEntryDtoToJSON,
    OemRateEntryDtoToJSONTyped,
} from './OemRateEntryDto';

/**
 * 
 * @export
 * @interface OemSlaContractDto
 */
export interface OemSlaContractDto {
    /**
     * 
     * @type {string}
     * @memberof OemSlaContractDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof OemSlaContractDto
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof OemSlaContractDto
     */
    validTo?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof OemSlaContractDto
     */
    status: OemSlaContractDtoStatusEnum;
    /**
     * 
     * @type {Array<OemRateEntryDto>}
     * @memberof OemSlaContractDto
     */
    rateEntries: Array<OemRateEntryDto>;
}


/**
 * @export
 */
export const OemSlaContractDtoStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Expired: 'EXPIRED'
} as const;
export type OemSlaContractDtoStatusEnum = typeof OemSlaContractDtoStatusEnum[keyof typeof OemSlaContractDtoStatusEnum];


/**
 * Check if a given object implements the OemSlaContractDto interface.
 */
export function instanceOfOemSlaContractDto(value: object): value is OemSlaContractDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('rateEntries' in value) || value['rateEntries'] === undefined) return false;
    return true;
}

export function OemSlaContractDtoFromJSON(json: any): OemSlaContractDto {
    return OemSlaContractDtoFromJSONTyped(json, false);
}

export function OemSlaContractDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OemSlaContractDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
        'status': json['status'],
        'rateEntries': ((json['rateEntries'] as Array<any>).map(OemRateEntryDtoFromJSON)),
    };
}

export function OemSlaContractDtoToJSON(json: any): OemSlaContractDto {
    return OemSlaContractDtoToJSONTyped(json, false);
}

export function OemSlaContractDtoToJSONTyped(value?: OemSlaContractDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'validFrom': value['validFrom'].toISOString(),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString(),
        'status': value['status'],
        'rateEntries': ((value['rateEntries'] as Array<any>).map(OemRateEntryDtoToJSON)),
    };
}

